export const heroStats = [
  { label: '聚合平台数', value: '50+' },
  { label: '每日更新', value: '200+' },
  { label: '覆盖话题', value: '30+' },
];

export const cards = [
  {
    title: '顶流艺人恋情曝光，工作室回应引全网热议',
    summary: '近日某顶流艺人被拍到与神秘异性深夜同行，照片曝光后迅速登上热搜榜首，工作室凌晨发布声明引发新一轮讨论。',
    tag: '明星八卦',
    heat: '986万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20studio%20set%20with%20warm%20coral%20lighting%2C%20modern%20broadcasting%20equipment%20on%20dark%20wooden%20desk%2C%20abstract%20data%20visualization%20screens%20showing%20trending%20topics%2C%20professional%20atmosphere%20with%20cinematic%20mood%20lighting%2C%20deep%20shadows%20and%20bright%20highlights%2C%20editorial%20photography%20style%20with%20rich%20warm%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '年度综艺收视率排行出炉，黑马节目逆袭登顶',
    summary: '最新公布的年度综艺收视数据显示，一档低成本制作的素人真人秀意外成为年度最大黑马，打破了头部综艺垄断格局。',
    tag: '综艺热点',
    heat: '752万',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20abstract%20composition%20representing%20viral%20social%20media%20content%2C%20flowing%20geometric%20shapes%20in%20coral%20and%20amber%20gradients%2C%20overlapping%20translucent%20circles%20and%20lines%20suggesting%20network%20connectivity%2C%20clean%20minimal%20background%20in%20warm%20off-white%2C%20modern%20tech-meets-art%20aesthetic%2C%20soft%20diffused%20lighting%2C%20high-end%20editorial%20look&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '知名导演新作预告发布，豪华阵容备受期待',
    summary: '著名导演时隔五年携新作回归，预告片发布后24小时内播放量破亿，全明星阵容加之宏大制作规模引发影迷强烈期待。',
    tag: '影视资讯',
    heat: '1,203万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20representation%20of%20online%20community%20discussion%20and%20trending%20topics%2C%20layered%20abstract%20shapes%20suggesting%20conversation%20threads%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20subtle%20texture%20patterns%20resembling%20digital%20interfaces%2C%20sophisticated%20modern%20composition%20with%20depth%2C%20editorial%20design%20style%2C%20light%20cream%20background&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '音乐榜单大洗牌，新生代歌手强势霸榜',
    summary: '本周各大音乐平台排行榜出现罕见大换血，多位95后、00后新生代歌手作品同时冲入前十，标志华语乐坛更新换代加速。',
    tag: '音乐动态',
    heat: '631万',
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20illustration%20of%20hot%20topic%20discussions%20in%20digital%20space%2C%20abstract%20flame-like%20shapes%20in%20coral%20and%20amber%20tones%2C%20floating%20text-like%20elements%20suggesting%20social%20media%20posts%2C%20clean%20geometric%20composition%20on%20warm%20neutral%20background%2C%20modern%20graphic%20design%20aesthetic%20with%20subtle%20gradients%2C%20professional%20editorial%20quality&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '热播剧大结局收视破纪录，网友二创热潮持续',
    summary: '现象级热播剧迎来大结局，直播收视率突破历史纪录，社交媒体话题量超百亿，粉丝自发二创作品在各平台持续刷屏。',
    tag: '影视资讯',
    heat: '1,580万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20image%20of%20entertainment%20industry%20news%20coverage%2C%20abstract%20microphone%20and%20camera%20lens%20shapes%20in%20warm%20metallic%20tones%2C%20coral%20accent%20lighting%20creating%20dramatic%20atmosphere%2C%20sophisticated%20composition%20on%20cream%20background%2C%20high-end%20magazine%20editorial%20style%2C%20soft%20shadows%20and%20refined%20details&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '国际电影节华语片斩获大奖，口碑持续走高',
    summary: '某华语独立电影在三大国际电影节之一斩获最高荣誉，评委会称赞其独特的叙事视角和深刻的社会洞察。',
    tag: '国际娱乐',
    heat: '478万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20composition%20of%20digital%20content%20creation%20and%20viral%20trends%2C%20abstract%20upward%20trending%20arrows%20and%20graphs%20in%20warm%20gold%2C%20flowing%20ribbon-like%20shapes%20in%20coral%2C%20clean%20modern%20aesthetic%20on%20off-white%20background%2C%20professional%20graphic%20design%20quality%2C%20subtle%20depth%20and%20dimensional%20feel&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    title: '网红翻车事件持续升级，多方回应引发关注',
    summary: '头部带货主播因产品质量争议陷入舆论漩涡，品牌方、平台方、消费者协会相继发声，事件仍在持续发酵中。',
    tag: '网红圈',
    heat: '892万',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20illustration%20of%20online%20engagement%20and%20community%20interaction%2C%20interconnected%20circle%20motifs%20in%20coral%20and%20gold%2C%20subtle%20geometric%20patterns%20suggesting%20digital%20networks%2C%20warm%20cream%20background%20with%20gentle%20gradient%2C%20contemporary%20editorial%20design%2C%20professional%20polished%20finish&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export const features = [
  {
    icon: 'ri-global-line',
    title: '全网聚合',
    desc: '整合51吃瓜、91吃瓜、17吃瓜等多平台入口资源，一站式浏览全网八卦热点，无需反复切换站点。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '24小时不间断追踪最新娱乐动态与八卦资讯，热点事件发生第一时间推送到平台首页。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全浏览',
    desc: '采用加密传输技术保障用户隐私与浏览安全，所有访问链路均经过多层安全防护。',
  },
  {
    icon: 'ri-stack-line',
    title: '多元内容',
    desc: '涵盖明星八卦、影视综艺、音乐时尚、网红生态、国际娱乐等30多个内容品类。',
  },
];

export const faqs = [
  {
    q: '吃瓜在线是什么平台？',
    a: '吃瓜在线是一个综合性娱乐资讯聚合平台，整合了51吃瓜在线、91吃瓜在线、17吃瓜在线等多个热门入口，为用户提供一站式八卦浏览体验。平台涵盖娱乐新闻、明星动态、影视资讯、综艺热点、网红生态等多领域内容，是广大网友获取第一手娱乐资讯的首选入口。',
  },
  {
    q: '如何找到吃瓜在线最新地址？',
    a: '由于平台流量较大，域名可能会不定期更新。建议您收藏当前页面，或关注吃瓜在线官方社交媒体账号获取最新入口地址。本站持续维护51吃瓜在线、91吃瓜在线等关联平台的入口链接，确保用户始终能够快速访问。',
  },
  {
    q: '51吃瓜在线和91吃瓜在线有什么区别？',
    a: '51吃瓜在线和91吃瓜在线同为吃瓜品牌旗下的内容站点，51吃瓜侧重于明星八卦与综艺娱乐，91吃瓜则更偏向于社会热点与深度爆料。两者内容各有侧重、互为补充，用户可根据自己的兴趣偏好选择浏览。',
  },
  {
    q: '吃瓜在线平台内容多久更新一次？',
    a: '吃瓜在线平台实行7×24小时不间断更新机制，编辑团队全天候监控全网热点动态，确保用户随时访问都能获取到最新鲜的资讯内容。每日更新资讯数量超过200条，覆盖30余个内容品类。',
  },
  {
    q: '如何向吃瓜在线投稿或提供线索？',
    a: '欢迎广大网友通过本站的联系投稿入口提交线索或原创内容。请提供详细的事件描述和相关证据材料，我们的编辑团队将在24小时内进行审核。审核通过的内容将在平台发布，并为投稿人提供相应署名。',
  },
];

export const topics = [
  { name: '明星八卦', heat: '1,286万', icon: 'ri-star-line' },
  { name: '综艺热点', heat: '958万', icon: 'ri-tv-line' },
  { name: '影视资讯', heat: '1,102万', icon: 'ri-film-line' },
  { name: '音乐动态', heat: '734万', icon: 'ri-music-line' },
  { name: '网红生态', heat: '892万', icon: 'ri-live-line' },
  { name: '社会热议', heat: '1,445万', icon: 'ri-fire-line' },
  { name: '体育娱乐', heat: '621万', icon: 'ri-basketball-line' },
  { name: '时尚潮流', heat: '467万', icon: 'ri-shirt-line' },
  { name: '科技趣闻', heat: '389万', icon: 'ri-smartphone-line' },
  { name: '国际娱乐', heat: '545万', icon: 'ri-earth-line' },
  { name: '二次元', heat: '678万', icon: 'ri-gamepad-line' },
];

export const indices = [
  { title: '娱乐圈内幕揭秘', count: '156篇', desc: '深度挖掘娱乐圈不为人知的幕后故事与行业内情' },
  { title: '综艺节目深度解析', count: '89篇', desc: '热门综艺台前幕后的全面分析与专业解读' },
  { title: '明星穿搭大盘点', count: '234篇', desc: '红毯、街拍、私服全方位时尚解读与同款推荐' },
  { title: '热门影视追踪', count: '198篇', desc: '热播影视剧的剧情分析、演员表现与口碑追踪' },
  { title: '音乐榜单速递', count: '112篇', desc: '各大音乐平台排行榜最新动态与趋势分析' },
  { title: '网红生态观察', count: '167篇', desc: '直播带货、短视频创作者的发展动态与行业趋势' },
  { title: '社会话题讨论', count: '203篇', desc: '社会热点事件的多角度讨论与网友观点精选' },
  { title: '海外娱乐资讯', count: '78篇', desc: '欧美日韩等海外娱乐圈的最新动态与热点事件' },
  { title: '粉丝文化研究', count: '45篇', desc: '饭圈文化、应援经济与粉丝社群生态的专业研究' },
];

export const updates = [
  { date: '2026-07-30', time: '14:32', content: '新增51吃瓜在线镜像入口，访问速度提升50%' },
  { date: '2026-07-29', time: '09:15', content: '平台日活跃用户突破百万大关，感谢每一位吃瓜群众' },
  { date: '2026-07-28', time: '18:40', content: '上线全新话题标签系统，浏览体验全面优化升级' },
  { date: '2026-07-27', time: '11:20', content: '国际娱乐板块正式上线，覆盖欧美日韩最新资讯' },
  { date: '2026-07-26', time: '16:05', content: '安全防护系统全面升级，用户隐私保障再上新台阶' },
  { date: '2026-07-25', time: '08:50', content: '开放用户投稿通道，已有超过500篇优质投稿发布' },
  { date: '2026-07-24', time: '20:18', content: '移动端适配完成，手机浏览体验全面优化' },
  { date: '2026-07-23', time: '13:45', content: '新增91吃瓜在线快捷入口，平台矩阵持续扩展中' },
];

export const rankings = [
  { rank: 1, title: '顶流恋情风波全记录', heat: '1,286万', trend: 'up', tag: '明星八卦' },
  { rank: 2, title: '热播剧大结局现象级热议', heat: '1,102万', trend: 'up', tag: '影视资讯' },
  { rank: 3, title: '年度综艺收视率黑马逆袭', heat: '958万', trend: 'up', tag: '综艺热点' },
  { rank: 4, title: '网红带货翻车事件追踪', heat: '892万', trend: 'up', tag: '网红生态' },
  { rank: 5, title: '新生代歌手集体霸榜', heat: '734万', trend: 'up', tag: '音乐动态' },
  { rank: 6, title: '国际电影节华语片获奖', heat: '621万', trend: 'new', tag: '国际娱乐' },
  { rank: 7, title: '社会热点引发全民讨论', heat: '545万', trend: 'up', tag: '社会热议' },
];

export const mediaItems = [
  {
    title: '独家揭秘：顶流艺人私生活的另一面',
    duration: '15:28',
    views: '286万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20composition%20of%20entertainment%20news%20broadcast%20scene%2C%20modern%20studio%20setting%20with%20warm%20amber%20lighting%2C%20abstract%20screen%20displays%20showing%20trending%20content%2C%20professional%20broadcasting%20atmosphere%2C%20rich%20warm%20color%20palette%20with%20coral%20accents%2C%20high-end%20production%20quality%2C%20dramatic%20shadows&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '影视圈年度盘点：那些惊艳了时光的作品',
    duration: '22:45',
    views: '198万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20representation%20of%20digital%20media%20streaming%20platform%2C%20abstract%20play%20button%20and%20waveform%20shapes%20in%20coral%20and%20gold%2C%20modern%20tech%20aesthetic%20on%20warm%20neutral%20background%2C%20sleek%20contemporary%20design%2C%20editorial%20quality%20composition%20with%20depth%20and%20dimension&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '综艺幕后故事：制作人亲述爆款诞生记',
    duration: '18:36',
    views: '345万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20visual%20of%20celebrity%20gossip%20and%20entertainment%20coverage%2C%20abstract%20paparazzi%20flash%20shapes%20in%20golden%20tones%2C%20sophisticated%20magazine%20editorial%20style%2C%20warm%20moody%20lighting%20with%20coral%20highlights%2C%20professional%20photography%20aesthetic%2C%20rich%20atmospheric%20composition&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '音乐圈大变局：新生代如何改写行业规则',
    duration: '12:50',
    views: '167万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20artistic%20composition%20of%20news%20aggregation%20and%20content%20curation%2C%20layered%20abstract%20newspaper%20and%20digital%20screen%20shapes%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20clean%20contemporary%20design%20on%20cream%20background%2C%20editorial%20quality%20with%20refined%20details&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '网红经济深度观察：流量背后的商业逻辑',
    duration: '25:12',
    views: '432万',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20illustration%20of%20viral%20content%20discovery%20platform%2C%20abstract%20magnifying%20glass%20and%20trend%20indicators%20in%20gold%20and%20coral%2C%20sophisticated%20modern%20graphic%20design%2C%20warm%20off-white%20background%2C%20professional%20polished%20aesthetic%20with%20subtle%20textures&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '2026娱乐圈年中盘点：上半年最值得关注的十大事件',
    summary: '从顶流恋情到影坛新作，从综艺黑马到音乐榜单洗牌，全面回顾上半年娱乐圈的重大事件与趋势变化。',
    tag: '特别策划',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20wide%20composition%20of%20entertainment%20industry%20headquarters%2C%20modern%20architectural%20shapes%20in%20warm%20tones%2C%20abstract%20representation%20of%20media%20production%2C%20cinematic%20lighting%20with%20coral%20and%20gold%20accents%2C%20sophisticated%20editorial%20photography%20style%2C%20rich%20atmospheric%20depth&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '吃瓜文化现象研究：从围观到参与的全民娱乐新生态',
    summary: '深入探讨「吃瓜」如何从网络流行语演变为一种独特的文化现象，以及它对当代社交行为和娱乐消费方式的深远影响。',
    tag: '深度观察',
    image: 'https://readdy.ai/api/search-image?query=Expansive%20artistic%20illustration%20of%20digital%20content%20ecosystem%2C%20flowing%20interconnected%20networks%20in%20coral%20and%20amber%2C%20abstract%20representation%20of%20information%20flow%2C%20warm%20cream%20background%20with%20subtle%20gradient%2C%20modern%20graphic%20design%20aesthetic%2C%20professional%20editorial%20quality&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国际视野下的华语娱乐：文化出海的机遇与挑战',
    summary: '随着华语影视作品在国际市场屡获佳绩，探讨华语娱乐内容走向全球的现状、策略与未来可能的发展路径。',
    tag: '行业分析',
    image: 'https://readdy.ai/api/search-image?query=Bold%20contemporary%20composition%20of%20trending%20entertainment%20news%2C%20abstract%20headline%20shapes%20and%20social%20media%20symbols%20in%20warm%20coral%20and%20gold%2C%20dramatic%20lighting%20effects%2C%20sophisticated%20magazine%20cover%20style%2C%20rich%20warm%20tones%20with%20high%20contrast%2C%20editorial%20excellence&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '数字时代的娱乐消费：短视频如何重塑内容传播格局',
    summary: '分析短视频平台对传统娱乐内容生产与传播模式的颠覆性影响，以及在这一趋势下吃瓜在线平台的应对策略。',
    tag: '趋势洞察',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20panoramic%20view%20of%20online%20community%20and%20discussion%20platform%2C%20abstract%20crowd%20shapes%20forming%20dynamic%20patterns%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20modern%20digital%20art%20style%20on%20cream%20background%2C%20professional%20composition%20with%20depth&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export const comments = [
  {
    avatar: '匿',
    name: '吃瓜群众A',
    time: '2小时前',
    content: '终于找到一个整合这么全的平台了！之前总要在51吃瓜和91吃瓜之间来回切换，现在一个站全搞定，太方便了。更新速度也快，基本每天都有新鲜内容看。',
    likes: '1,286',
  },
  {
    avatar: '卷',
    name: '娱乐小雷达',
    time: '5小时前',
    content: '作为资深吃瓜群众，对比过好几个同类站点，吃瓜在线在内容覆盖面和更新频率上确实领先不少。特别是影视和综艺板块，深度解析做得很到位，不是简单的信息搬运。',
    likes: '892',
  },
  {
    avatar: '乐',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '深夜睡不着就来刷吃瓜在线，已经成为每天的固定习惯了。希望平台能一直保持这个质量，也会推荐给身边爱吃瓜的朋友们。另外提个小建议，能否增加一个收藏功能？',
    likes: '567',
  },
];